const KEYS = ['sp_token', 'sp_refresh_token', 'sp_expires_at', 'sp_email', 'sp_demo'];

export function createSessionManager(storage, refresh) {
  let generation = 0;
  let pending = null;
  const clear = () => {
    generation++;
    pending = null;
    for (const key of KEYS) storage.removeItem(key);
  };
  const save = (session) => {
    if (!session.token) throw new Error('Session did not include an access token');
    clear();
    storage.setItem('sp_token', session.token);
    if (session.refresh_token) storage.setItem('sp_refresh_token', session.refresh_token);
    if (session.expires_at) storage.setItem('sp_expires_at', session.expires_at);
    if (session.email) storage.setItem('sp_email', session.email);
    if (session.is_demo) storage.setItem('sp_demo', '1');
  };
  const accessToken = async () => {
    const token = storage.getItem('sp_token');
    const refreshToken = storage.getItem('sp_refresh_token');
    const expiry = Number(storage.getItem('sp_expires_at'));
    if (!token || !refreshToken || expiry > Date.now() / 1000 + 60) return token;
    if (pending) return pending;
    const started = generation;
    const previousEmail = storage.getItem('sp_email');
    pending = (async () => {
      try {
        const next = await refresh(refreshToken);
        if (generation !== started || storage.getItem('sp_refresh_token') !== refreshToken) {
          throw new Error('Session changed during refresh');
        }
        save({...next, email: next.email || previousEmail});
        return next.token;
      } catch (error) {
        if (generation === started && error.status === 401) clear();
        throw error;
      } finally {
        if (generation === started) pending = null;
      }
    })();
    return pending;
  };
  return {save, clear, accessToken};
}
